import { Box } from "@chakra-ui/react"
import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import BulletSeparation from "@pathwright/ui/src/components/ui/BulletSeparation"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import styled from "styled-components"
import { usePathwrightContext } from "../../../../pathwright/PathwrightContext"
import { TreeNode } from "../../../state/tree/path-tree"
import { When } from "../../../ui/meta"
import FeedbackReviewers from "../../../ui/meta/FeedbackReviewers"

const PanelSectionMetaContainer = styled(BulletSeparation)`
  color: rgba(0, 0, 0, 0.5);
  width: 100%;
  font-size: 0.8em;

  span {
    white-space: nowrap;
  }
`

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;

  .name-and-status {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.2em;

    h1 {
      margin: 0px;
      font-weight: bold;
      font-size: 18px;
      margin-right: 6px !important;
    }
  }

  > .Avatar {
    margin-right: 10px;
  }
`

const ProfilePanelReviewers = ({ item }: { item: TreeNode<"completion"> }) => {
  return <FeedbackReviewers item={item} limit={3} />
}

const ProfilePanelSectionContainer = styled.div`
  margin-bottom: 1px;
  padding: 20px;
  position: relative;
  /* background-color: rgba(255, 255, 255, 0.08); */
`

const CompletionStatusContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.8em;
  .Pathicon {
    font-size: 12px;
    margin-right: 4px;
  }
  /* text-transform: uppercase; */
`

const CompletionStatus = ({ item }: { item: TreeNode<"completion"> }) => {
  const { me } = usePathwrightContext()
  const {
    data: {
      completion: { completion_date, is_skipped, overridden_by }
    }
  } = item
  const { t } = useTranslate()
  const completionLabel = completion_date
    ? is_skipped
      ? t("Skipped")
      : t("Completed")
    : t("Incomplete")
  const icon = completion_date ? "check" : "x"
  const tooltip =
    is_skipped && overridden_by
      ? me && overridden_by.id === me.id
        ? t("Skipped by you")
        : t("Skipped by {{ user }}", { user: overridden_by.display_name })
      : completionLabel
  return (
    <Tooltip title={tooltip}>
      <CompletionStatusContainer>
        <Pathicon icon={icon} />
        {completionLabel}
      </CompletionStatusContainer>
    </Tooltip>
  )
}

export const ProfilePanelSection = ({
  item,
  onSelect
}: {
  item: TreeNode<"completion">
  onSelect?: () => void
}) => {
  const selectProps = {
    onClick: onSelect,
    style: {
      cursor: onSelect ? "pointer" : "normal"
    }
  }

  return (
    <ProfilePanelSectionContainer className="ProfilePanelSection">
      <Box
        pos="absolute"
        inset={0}
        borderTopRadius="20px"
        bg="rgba(255, 255, 255, 0.8)"
      />
      <ProfileContainer>
        <Avatar size="2.5em" user={item.user} {...selectProps} />
        <div>
          <div className="name-and-status">
            <h1 {...selectProps}>{item.user?.full_name}</h1>
            <CompletionStatus item={item} />
          </div>
          <PanelSectionMetaContainer>
            <When item={item} showDueStatus />
            <ProfilePanelReviewers item={item} />
          </PanelSectionMetaContainer>
        </div>
      </ProfileContainer>
    </ProfilePanelSectionContainer>
  )
}
